import React from "react";

import { getPreviewFrameFontSize } from "@/utils/qrEditorHelper";

import { QRFRameProps } from "../types";

import "../styles.scss";

export const whiteFrame = (
  props: Omit<QRFRameProps, "frameType">
): React.SVGProps<SVGSVGElement> => {
  const { text, textColor, children, frameColor, frameBackgroundColor, urlQr } = props;

  const fontSize = getPreviewFrameFontSize(text?.length);

  return (
    <svg
      width="72"
      height="96"
      viewBox="0 0 72 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        width="72"
        height="96"
        rx="4"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M69 1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V69C1.5 69.8284 2.17157 70.5 3 70.5H69C69.8284 70.5 70.5 69.8284 70.5 69V3C70.5 2.17157 69.8284 1.5 69 1.5ZM3 0C1.34315 0 0 1.34315 0 3V69C0 70.6569 1.34315 72 3 72H69C70.6569 72 72 70.6569 72 69V3C72 1.34315 70.6569 0 69 0H3Z"
        fill={frameColor}
      />
      <rect
        x="4.5"
        y="4.5"
        width="62.4"
        height="62.4"
        fill="white"
      />
      <foreignObject
        width="88%"
        height="64px"
        x="4"
        y="4">
        <div
          id="#qrCode"
          style={{
            border: `1px solid ${frameBackgroundColor || "white"}`,
            width: "100%",
            height: "100%",
            boxSizing: "border-box",
            backgroundColor: "white",
          }}>
          {urlQr ? (
            <img
              src={urlQr}
              width="100%"
              height="auto"
            />
          ) : (
            children
          )}
        </div>
      </foreignObject>
      <foreignObject
        width="100%"
        height="18px"
        y="72">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{ width: "100%", height: "100%", maxWidth: "100%" }}>
          <text
            x="50%"
            y="10"
            fill={textColor}
            dominantBaseline="middle"
            textAnchor="middle"
            fontFamily="sans-serif"
            fontWeight="bold"
            style={{ fontSize }}>
            {text}
          </text>
        </svg>
      </foreignObject>
    </svg>
  );
};
